/* Shared cart-add helpers used by the `multiple-quantities` and
   `frequently-bought` blocks. Previously duplicated inline in
   snippets/product-blocks.liquid (lines 362 and 1990). */
(function () {
  'use strict';

  async function addProductsToCart(products) {
    const cartAddUrl = '/cart/add.js';
    const sectionIds = ['ajax-cart-drawer', 'cart-count'];

    const payload = {
      items: products,
      sections: sectionIds,
    };

    try {
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error adding products to cart:', errorText);
      }

      const cart = await response.json();

      if (typeof updatePrices === 'function') {
        updatePrices(localStorage.getItem('VATApplied') === 'true');
      }

      await openCartDrawer(cart);
    } catch (error) {
      console.error('Error adding products to cart:', error);
    }
  }

  async function openCartDrawer(cart) {
    const sectionId = 'ajax-cart-drawer';

    if (!cart || !cart.sections || !cart.sections[sectionId]) {
      console.error('Section not found in cart:', sectionId);
      return;
    }

    const updateCartHtml = new DOMParser()
      .parseFromString(cart.sections[sectionId], 'text/html')
      .querySelector('.shopify-section');

    if (!updateCartHtml) {
      console.error('Failed to parse HTML for section:', sectionId);
      return;
    }

    const updateCartContent = updateCartHtml.innerHTML;
    const cartBody = document.querySelector('[data-cart-drwaer-body]');
    if (!cartBody) {
      console.error('Cart drawer body element not found');
      return;
    }

    let cartItemcount = 0;
    const cartWrapper = updateCartHtml.querySelector('[data-cart-wrapper]');
    if (cartWrapper) {
      cartItemcount = parseInt(cartWrapper.getAttribute('data-item-count'));
    }

    cartBody.innerHTML = updateCartContent;

    if (cartItemcount > 0 && typeof getQuantityElement === 'function') {
      await getQuantityElement(cartBody);
    }

    if (typeof cartCountUpdate === 'function') await cartCountUpdate(cartItemcount);
    if (typeof cartNoteUpdate === 'function') await cartNoteUpdate();
    if (typeof getCartItemRemoveElements === 'function') await getCartItemRemoveElements(cartBody);
    if (typeof cartGiftWrapElement === 'function') await cartGiftWrapElement(cartBody);
    if (typeof cartTermhandlerClick === 'function') await cartTermhandlerClick();
    if (typeof cartTermsHandler === 'function') await cartTermsHandler();

    setTimeout(async function () {
      const cartDrawer = document.querySelector('.cart-drawer');
      const Quickview = document.querySelector('.quickview-drawer');
      const Comparemodel = document.querySelector('[data-compare-model]');
      if (Quickview) {
        Quickview.classList.remove('sidebar-visible');
        setTimeout(function () {
          Quickview.style.display = 'none';
        }, 300);
      }
      if (Comparemodel && cartDrawer) {
        if (
          cartDrawer.classList.contains('sidebar-visible') &&
          Comparemodel.querySelector('.compare-modal-content')
        ) {
          Comparemodel.querySelector('.compare-modal-content').classList.remove('popup-visible');
        }
      }
    }, 100);

    setTimeout(async function () {
      const cartDrawer = document.querySelector('.cart-drawer');
      if (cartDrawer) {
        cartDrawer.classList.add('sidebar-visible');
      }
      setTimeout(function () {
        if (typeof focusElementsRotation === 'function') {
          focusElementsRotation(cartDrawer);
        }
      }, 500);
    }, 500);

    const cartDrawer = document.querySelector('.cart-drawer');
    if (!cartDrawer) return;
    const recommendProducts = cartDrawer.querySelector('[data-recommendation-popup]');
    if (recommendProducts && !recommendProducts.classList.contains('active')) {
      setTimeout(() => {
        recommendProducts.classList.add('active');
      }, 1000);
      if (typeof slideshowElements === 'function') await slideshowElements();
    }

    cartDrawer.style.display = 'flex';
    document.querySelector('body').classList.add('no-scroll');
  }

  // Expose as globals so existing inline click handlers can call them.
  window.addProductsToCart = addProductsToCart;
  window.openCartDrawer = openCartDrawer;
})();
